<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Shop Right Sidebar" mainTitle="Shop Right Sidebar" />
  <ShopRightSidebar />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import ShopRightSidebar from "../components/ShopRightSidebar/ShopRightSidebar.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "ShopRightSidebarPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    ShopRightSidebar,
    DownloadTheApp,
    MainFooter,
  },
});
</script>